// extracted by mini-css-extract-plugin
module.exports = {"container":"PublicationSection_container_3uYt2","addNew":"PublicationSection_addNew_3lWVi","spinAround":"PublicationSection_spinAround_1LmDK"};